// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UndefinedImageTile_wrapper__enBoL","main":"UndefinedImageTile_main__C5VRo","title":"UndefinedImageTile_title__yQIj1","background":"UndefinedImageTile_background__iBD8h"};